export const SKELETON_SLIDES = [0, 1, 2, 3];
export const SLIDE_SIZE = 250;
